import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { constant, identity } from 'lodash';
import { createStructuredSelector } from 'reselect';

// Utils
import dontUpdateForKeys from '../../utils/milanoteRecompose/dontUpdateForKeys';
import { getGridSize } from '../../utils/grid/gridSizeSelector';

// Components
import ColorSwatch from './ColorSwatch';
import captionContainerDecorator from '../../components/caption/captionContainerDecorator';
import elementSaveMediaResizeDecorator from '../resizing/elementSaveMediaResizeDecorator';
import elementLineEdgeDropTarget from '../line/elementLineEdgeDropTarget';
import elementResizeDecorator from '../resizing/elementResizeDecorator';
import colorSwatchDoubleClickResizeDecorator from './colorSwatchDoubleClickResizeDecorator';
import ImageColorPaletteObserver from '../../components/images/imageColorExtraction/ImageColorPaletteObserver';

// Constants
import {
    COLOR_SWATCH_MIN_HEIGHT_GRID,
    COLOR_SWATCH_MIN_WIDTH_GRID,
} from '../../../common/colorSwatches/colorSwatchesConstants';

const mapStateToProps = createStructuredSelector({
    gridSize: getGridSize,
});

@connect(mapStateToProps)
@elementLineEdgeDropTarget
@dontUpdateForKeys(['dragModifierKeys', 'canDrop'])
@captionContainerDecorator
@elementResizeDecorator({
    getMinWidth: constant(COLOR_SWATCH_MIN_WIDTH_GRID),
    enableHeight: true,
})
@elementSaveMediaResizeDecorator({
    getMinWidth: constant(COLOR_SWATCH_MIN_WIDTH_GRID),
    getMinHeight: constant(COLOR_SWATCH_MIN_HEIGHT_GRID),
    getIsEnabled: () => true,
})
@colorSwatchDoubleClickResizeDecorator
class ColorSwatchContainer extends React.Component {
    setElementSize = (size) => {
        const { setElementSize } = this.props;
        return setElementSize(size);
    };

    handleKey = (event) => {
        if (!this.props.isSelected) return;
        this.props.captionKeyHandler(event, this.props);
    };

    render() {
        const { connectLineEdgeDropTarget, canConnectLineEdge } = this.props;

        const lineEdgeConnector =
            connectLineEdgeDropTarget && canConnectLineEdge ? connectLineEdgeDropTarget : identity;

        return lineEdgeConnector(
            <div>
                <ImageColorPaletteObserver element={this.props.element} />
                <ColorSwatch
                    {...this.props}
                    handleKey={this.handleKey}
                    setElementSize={this.setElementSize}
                    cropToGrid={!this.props.isResizing}
                />
            </div>,
        );
    }
}

ColorSwatchContainer.propTypes = {
    element: PropTypes.object.isRequired,
    attachment: PropTypes.object,
    connectDropTarget: PropTypes.func,
    connectLineEdgeDropTarget: PropTypes.func,
    isSelected: PropTypes.bool,
    captionKeyHandler: PropTypes.func,
    inList: PropTypes.string,
    setElementSize: PropTypes.func,
    boardSection: PropTypes.string,
    canConnectLineEdge: PropTypes.bool,
    isResizing: PropTypes.bool,
};

export default ColorSwatchContainer;
